import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { _HttpClient } from '@delon/theme';

import { SelectBaseComponent } from '../select-base';
import { SelectInstantBaseComponent } from '../selectInstant-base';

@Component({
  selector: 'app-uom-select',
  templateUrl: './uom-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UOMSelectComponent),
      multi: true
    }
  ]
})
export class UOMSelectComponent extends SelectInstantBaseComponent {
  @Input() stockId: string = '';
  dropdownPlacement: 'bottomLeft' | 'topLeft' = 'bottomLeft';

  constructor(
    http: _HttpClient,
    router: Router,
    cdr: ChangeDetectorRef
  ) {
    super(http, cdr, router);
    this.valueField = '';
  }

  private updateDropdownPlacementFromViewport(): void {
    try {
      const hostEl = this.selector?.originElement?.nativeElement as
        | HTMLElement
        | undefined;
      const rect = hostEl?.getBoundingClientRect();
      if (!rect) return;

      const desiredDropdownHeight = 260;
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      this.dropdownPlacement =
        spaceBelow < desiredDropdownHeight && spaceAbove > spaceBelow
          ? 'topLeft'
          : 'bottomLeft';
    } catch {}
  }

  handleOpenChange(open: boolean): void {
    if (open) this.updateDropdownPlacementFromViewport();
    this.search('');
  }

  override handleClick(event: MouseEvent): void {
    this.updateDropdownPlacementFromViewport();
    super.handleClick(event);
  }

  override handleKeyDown(event: KeyboardEvent): void {
    this.updateDropdownPlacementFromViewport();
    super.handleKeyDown(event);
  }

  getUrl(searchValue: string): string {
    let filter = `isActive eq true and stockId eq ${this.stockId}`;
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      filter = `(${filter}) and (contains(code, '${encodeURIComponent(
        searchStr
      )}') or contains(description,'${encodeURIComponent(searchStr)}'))`;
    }
    return `api/uoms/lookup?$top=50&$skip=0&$orderby=code asc&$filter=${filter}`;
  }

  // set the location want to navigate
  jump(): string {
    return `/stk/stock/detail/${this.stockId}`;
  }

  // set the param 
  queryParam(): String {
    return 'UOMCode';
  }
}
